import { getUpdatedCheckedItemsList } from "utils"
import {
  GET_EVENTS_SUCCESS,
  RESET_EVENTS,
  SHOW_LOADING_INDICATOR,
  HIDE_LOADING_INDICATOR,
  GET_EVENTS_FAILED,
  GET_EVENTS,
  CHANGE_EVENT_PUBLISH_FIELD_SUCCESS,
  SELECT_SINGLE_EVENT,
  SELECT_ALL_EVENTS,
  UPDATE_CATEGORIZED_EVENT_ORDER,
  RESET_EVENTS_SELECTION,
  SET_EVENTS_SORT_OPTIONS,
  UPDATE_EVENT_ORDER,
  OPEN_PUBLISH_NOTIFICATION_MODAL,
  HIDE_PUBLISH_NOTIFICATION_MODAL,
  CHANGE_EVENT_PUBLISH_FIELD_FAILED,
  OPEN_DELETE_EVENT_MODAL,
  HIDE_DELETE_EVENT_MODAL,
  HANDLE_DELETE_EVENT_SUCCESS,
  OPEN_EVENT_BULK_DELETE_MODAL,
  HIDE_EVENT_BULK_DELETE_MODAL,
  HANDLE_EVENT_BULK_DELETE_SUCCESS,
  GET_SELECTED_EVENT_SUCCESS,
  ADD_NEW_EXPERIENCE,
  RESET_SELECTED_EVENT,
  GET_EVENT_INVITE_LIST_SUCCESS,
  SEND_INVITES_SUCCESS,
  RESET_EVENT_INVITE_LIST,
  DELETE_INVITE_SUCCESS,
  ADD_ACCESS_CODE_SUCCESS,
  OPEN_SAVING_MODAL,
  HIDE_SAVING_MODAL,
  SET_EVENT_INVITE_LIST_SORT_OPTIONS,
  EDIT_ATTENDEE_SUCCESS,
  OPEN_INACTIVE_EVENT_WARNING_MODAL,
  HIDE_INACTIVE_EVENT_WARNING_MODAL,
  UPDATE_RSVP_SUCCESS,
  EDIT_ATTENDEE_AND_RSVP_SUCCESS,
  DELETE_RSVP_SUCCESS,
  UPDATE_EVENT_ACCESS_TYPE_SUCCESS,
  GET_EVENT_MENU_LIST_SUCCESS,
  UPDATE_EXPERIENCE_SUCCESS,
  GET_EVENT_ACCESS_CODES_SUCCESS,
  GET_INITIAL_ACCESS_TAGS_SUCCESS,
  JOIN_EVENT_SUCCESS,
  GET_EVENT_CATEGORIES_SUCCESS,
  ADD_NEW_EXPERIENCE_SUCCESS,
  GET_EVENT_CODES_SUCCESS,
  UPDATE_BULK_PUBLISH_STATUS_SUCCESS,
  OPEN_EXPERIENCES_ERROR_MODAL,
  HIDE_EXPERIENCES_ERROR_MODAL,
  SEND_EMAIL_INVITE_SUCCESS,
  GET_EVENT_DEEPLINK_URL_SUCCESS,
  GET_EVENT_DEEPLINK_CODES_SUCCESS,
  GENERATE_DEEPLINK_CODES,
  GENERATE_DEEPLINK_CODES_FAILED,
  GENERATE_DEEPLINK_CODES_SUCCESS,
  GET_EVENT_DEEPLINK_CODES,
  GET_EVENT_DEEPLINK_CODES_FAILED,
  OPEN_GENERATE_DEEPLINK_MODAL,
  HIDE_GENERATE_DEEPLINK_MODAL,
  UPDATE_EVENT_MENU_FEATURES_ORDER,
  OPEN_EXP_CLONE_CONFIRMATION_MODAL,
  HIDE_EXP_CLONE_CONFIRMATION_MODAL,
  CLONE_EXPERIENCE,
  CLONE_EXPERIENCE_FAILED,
  CLONE_EXPERIENCE_SUCCESS,
  HANDLE_DELETE_EVENT,
  HANDLE_DELETE_EVENT_FAILED,
  HANDLE_EVENT_BULK_DELETE,
  HANDLE_EVENT_BULK_DELETE_FAILED,
  CHANGE_EVENT_PUBLISH_FIELD,
  UPDATE_BULK_PUBLISH_STATUS,
  UPDATE_BULK_PUBLISH_STATUS_FAILED,
} from "./actionTypes"

const INIT_STATE = {
  events: [],
  isEventsLoaded: false,
  error: {},
  showLoadingIndicator: true,
  selectedEvents: [],
  isAllEventSelected: false,
  eventsSortOptions: { o: "order", od: "asc" },
  isExperienceErrorModalOpen: false,
  isPublishNotificationModalOpen: false,
  errorMessage: "",
  isDeleteEventModalOpen: false,
  isEventBulkDeleteModalOpen: false,
  selectedEvent: null,
  showSavingModal: false,
  eventInviteList: {},
  isEditAttendeeModalOpen: false,
  accessCodes: [],
  eventInviteListSortOptions: { o: "name", od: "asc" },
  isInactiveEventWarningModalOpen: false,
  eventMenuList: [],
  initialAccessTags: [],
  selectedEventCategories: [],
  eventCodes: null,
  errorModalIsOpen: false,
  eventDeepLinkUrl: null,
  eventDeepLinkCodes: null,
  loading: false,
  deeplinkCodesAreLoading: false,
  generateDeeplinkModalIsOpen: false,
  cloneExpModalIsOpen: false,
  publishLoading: false,
}
const Experiences = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS:
      return {
        ...state,
        isEventsLoaded: false,
      }
    case GET_EVENTS_FAILED:
      return {
        ...state,
        isEventsLoaded: true,
      }
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
        isEventsLoaded: true,
      }
    case RESET_EVENTS:
      return {
        ...state,
        events: [],
      }
    case SHOW_LOADING_INDICATOR:
      return {
        ...state,
        showLoadingIndicator: true,
      }
    case HIDE_LOADING_INDICATOR:
      return {
        ...state,
        showLoadingIndicator: false,
      }
    case CHANGE_EVENT_PUBLISH_FIELD_SUCCESS:
      return {
        ...state,
        events: state.events.map(experience =>
          experience.id === action.payload?.data?.id
            ? {
                ...experience,
                published: action.payload?.data?.published,
                // updated_at: action.payload.updated_at * 1000,
              }
            : experience
        ),
        selectedEvent:
          action?.payload?.type === "list" ? null : action.payload?.data,
        loading: false,
        publishLoading: false,
      }
    case SELECT_SINGLE_EVENT:
      return {
        ...state,
        selectedEvents: getUpdatedCheckedItemsList(
          action.payload.experience,
          action.payload.isSelected,
          state.selectedEvents
        ),
      }
    case SELECT_ALL_EVENTS:
      return {
        ...state,
        isAllEventSelected: action.payload.isSelected,
        selectedEvents: action.payload.isSelected
          ? state.events.map(experience => experience.id)
          : [],
      }
    case RESET_EVENTS_SELECTION:
      return {
        ...state,
        isAllEventSelected: false,
        selectedEvents: [],
      }
    case SET_EVENTS_SORT_OPTIONS:
      return {
        ...state,
        eventsSortOptions: action.payload.sortOption,
      }
    case UPDATE_EVENT_ORDER:
      return {
        ...state,
        events: state.events.map(event =>
          action.payload.params.events
            .map(paramEvent => paramEvent.event_id)
            .includes(event.id)
            ? {
                ...event,
                order: action.payload.params.events.find(
                  paramEvent => paramEvent.event_id === event.id
                )?.order,
              }
            : event
        ),
      }
    case UPDATE_CATEGORIZED_EVENT_ORDER:
      return {
        ...state,
        events: state?.events?.map(event => {
          let currentEv = action.payload.params.events?.find(
            ev => ev?.event_id === event?.id
          )
          if (!currentEv) {
            return event
          } else {
            let categories = event?.categories?.map(category =>
              category?.category_id === action.payload.params.category_id
                ? { ...category, event_order: currentEv?.order }
                : category
            )
            return !!categories
              ? { ...event, categories: categories }
              : { ...event, order: currentEv?.order }
          }
        }),
      }
    case UPDATE_BULK_PUBLISH_STATUS_SUCCESS:
      return {
        ...state,
        events: state.events.map(event =>
          action.payload.event_ids.includes(event.id)
            ? { ...event, published: action.payload.published }
            : event
        ),
        loading: false,
      }
    case OPEN_PUBLISH_NOTIFICATION_MODAL:
      return {
        ...state,
        isPublishNotificationModalOpen: true,
      }
    case HIDE_PUBLISH_NOTIFICATION_MODAL:
      return {
        ...state,
        isPublishNotificationModalOpen: false,
      }
    case CHANGE_EVENT_PUBLISH_FIELD_FAILED:
      return {
        ...state,
        errorMessage: action.payload.error,
        loading: false,
        publishLoading: false,
      }
    case OPEN_DELETE_EVENT_MODAL:
      return {
        ...state,
        isDeleteEventModalOpen: true,
      }
    case HIDE_DELETE_EVENT_MODAL:
      return {
        ...state,
        isDeleteEventModalOpen: false,
      }
    case HANDLE_DELETE_EVENT:
    case HANDLE_EVENT_BULK_DELETE:
    case UPDATE_BULK_PUBLISH_STATUS:
      return {
        ...state,
        loading: true,
      }
    case CHANGE_EVENT_PUBLISH_FIELD:
      return {
        ...state,
        loading: true,
        publishLoading: true,
      }
    case HANDLE_DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(event => event.id !== action.payload.id),
        loading: false,
      }
    case HANDLE_DELETE_EVENT_FAILED:
    case HANDLE_EVENT_BULK_DELETE_FAILED:
    case UPDATE_BULK_PUBLISH_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      }
    case OPEN_EVENT_BULK_DELETE_MODAL:
      return {
        ...state,
        isEventBulkDeleteModalOpen: true,
      }
    case HIDE_EVENT_BULK_DELETE_MODAL:
      return {
        ...state,
        isEventBulkDeleteModalOpen: false,
      }
    case HANDLE_EVENT_BULK_DELETE_SUCCESS:
      return {
        ...state,
        events: state.events.filter(
          event => !action.payload.event_ids.includes(event.id)
        ),
        loading: false,
      }

    case OPEN_SAVING_MODAL:
      return {
        ...state,
        showSavingModal: true,
      }
    case HIDE_SAVING_MODAL:
      return {
        ...state,
        showSavingModal: false,
      }
    case ADD_NEW_EXPERIENCE:
      return {
        ...state,
      }
    case GET_SELECTED_EVENT_SUCCESS:
    case UPDATE_EXPERIENCE_SUCCESS:
    case ADD_NEW_EXPERIENCE_SUCCESS:
      return {
        ...state,
        selectedEvent: action.payload,
      }
    case RESET_SELECTED_EVENT:
      return {
        ...state,
        selectedEvent: null,
        accessCodes: [],
        selectedFeature: {},
        initialAccessTags: [],
        selectedEventCategories: [],
        eventCodes: null,
        eventDeepLinkUrl: null,
        eventDeepLinkCodes: null,
      }
    case SEND_INVITES_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case GET_EVENT_INVITE_LIST_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case RESET_EVENT_INVITE_LIST:
      return {
        ...state,
        eventInviteList: {},
        eventInviteListSortOptions: { o: "name", od: "asc" },
      }
    case DELETE_INVITE_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        selectedEvent: {
          ...state.selectedEvent,
          rsvps: state.selectedEvent?.rsvps.filter(x =>
            action.payload.data.map(data => data.user_id).includes(x.user_id)
          ),
        },
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case ADD_ACCESS_CODE_SUCCESS:
      return {
        ...state,
        accessCodes: [...state.accessCodes, action.payload],
      }
    case GET_EVENT_ACCESS_CODES_SUCCESS:
      return {
        ...state,
        accessCodes: action.payload,
      }
    case SET_EVENT_INVITE_LIST_SORT_OPTIONS:
      return {
        ...state,
        eventInviteListSortOptions: action.payload,
      }
    case EDIT_ATTENDEE_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case OPEN_INACTIVE_EVENT_WARNING_MODAL:
      return {
        ...state,
        isInactiveEventWarningModalOpen: true,
      }
    case HIDE_INACTIVE_EVENT_WARNING_MODAL:
      return {
        ...state,
        isInactiveEventWarningModalOpen: false,
      }
    case UPDATE_RSVP_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case EDIT_ATTENDEE_AND_RSVP_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case DELETE_RSVP_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
        eventInviteListSortOptions: {
          ...state.eventInviteListSortOptions,
          perPage: action.payload.per_page,
        },
      }
    case UPDATE_EVENT_ACCESS_TYPE_SUCCESS:
      return {
        ...state,
        selectedEvent: {
          ...state.selectedEvent,
          // updated_at: action.payload.updated_at * 1000,
          is_open: action.payload.is_open,
          access_type: action.payload.access_type,
        },
      }
    case GET_EVENT_MENU_LIST_SUCCESS:
      return {
        ...state,
        eventMenuList: action.payload,
      }
    case GET_INITIAL_ACCESS_TAGS_SUCCESS:
      return {
        ...state,
        initialAccessTags: action.payload,
      }
    case JOIN_EVENT_SUCCESS:
      return {
        ...state,
        selectedEvent: { ...state.selectedEvent, rsvps: action.payload },
      }
    case GET_EVENT_CATEGORIES_SUCCESS:
      return {
        ...state,
        selectedEventCategories: action.payload,
      }
    case GET_EVENT_CODES_SUCCESS:
      return {
        ...state,
        eventCodes: action.payload,
      }
    case OPEN_EXPERIENCES_ERROR_MODAL:
      return {
        ...state,
        errorMessage: action.payload || "Error",
        errorModalIsOpen: true,
      }
    case HIDE_EXPERIENCES_ERROR_MODAL:
      return {
        ...state,
        errorMessage: "",
        errorModalIsOpen: false,
      }
    case SEND_EMAIL_INVITE_SUCCESS:
      return {
        ...state,
        eventInviteList: action.payload,
      }
    case GET_EVENT_DEEPLINK_URL_SUCCESS:
      return {
        ...state,
        eventDeepLinkUrl: action.payload,
      }
    case GET_EVENT_DEEPLINK_CODES:
      return {
        ...state,
        eventDeepLinkCodes: null,
        deeplinkCodesAreLoading: true,
      }
    case GET_EVENT_DEEPLINK_CODES_FAILED:
      return {
        ...state,
        error: action.payload,
        deeplinkCodesAreLoading: false,
      }
    case GET_EVENT_DEEPLINK_CODES_SUCCESS:
      return {
        ...state,
        eventDeepLinkCodes: action.payload,
        deeplinkCodesAreLoading: false,
      }
    case GENERATE_DEEPLINK_CODES:
      return {
        ...state,
        loading: true,
      }
    case GENERATE_DEEPLINK_CODES_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GENERATE_DEEPLINK_CODES_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_GENERATE_DEEPLINK_MODAL:
      return {
        ...state,
        generateDeeplinkModalIsOpen: true,
      }
    case HIDE_GENERATE_DEEPLINK_MODAL:
      return {
        ...state,
        generateDeeplinkModalIsOpen: false,
      }
    case UPDATE_EVENT_MENU_FEATURES_ORDER:
      return {
        ...state,
        selectedEvent: {
          ...state.selectedEvent,
          design: action.payload?.params,
        },
      }
    case OPEN_EXP_CLONE_CONFIRMATION_MODAL:
      return {
        ...state,
        cloneExpModalIsOpen: true,
      }
    case HIDE_EXP_CLONE_CONFIRMATION_MODAL:
      return {
        ...state,
        cloneExpModalIsOpen: false,
      }
    case CLONE_EXPERIENCE:
      return {
        ...state,
        loading: true,
      }
    case CLONE_EXPERIENCE_FAILED:
      return {
        ...state,
        loading: false,
        cloneExpModalIsOpen: false,
        error: action.payload,
      }
    case CLONE_EXPERIENCE_SUCCESS:
      return {
        ...state,
        // selectedEvent: action.payload,
        loading: false,
        cloneExpModalIsOpen: false,
      }
    default:
      return state
  }
}

export default Experiences
